var map = {
	"./car.svg": "2553",
	"./equipment.svg": "321c",
	"./heavy_machinery.svg": "e8c3",
	"./pernik.svg": "707f",
	"./tool.svg": "064b",
	"./user_inventory.svg": "ac6af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0260";